import styled, { css } from "styled-components";
import { ShadowSideEnum } from "./types";

export const BetTypeSelectorContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ShortSelectorContainer = styled.div<{
  shadowSide?: ShadowSideEnum;
}>`
  position: relative;

  &::before,
  &::after {
    content: "";
    position: absolute;
    width: 44px;
    height: 32px;
    pointer-events: none;
    z-index: 1;
    top: 0;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }

  &::before {
    left: 0;
    opacity: ${({ shadowSide }) =>
      shadowSide === ShadowSideEnum.LEFT || shadowSide === ShadowSideEnum.BOTH
        ? 1
        : 0};
    background-image: linear-gradient(
      90deg,
      rgb(233 239 245 / 90%) 0%,
      rgb(233 239 245 / 0%) 100%
    );
  }

  &::after {
    right: 0;
    opacity: ${({ shadowSide }) =>
      shadowSide === ShadowSideEnum.RIGHT || shadowSide === ShadowSideEnum.BOTH
        ? 1
        : 0};
    background-image: linear-gradient(
      270deg,
      rgb(233 239 245 / 90%) 0%,
      rgb(233 239 245 / 0%) 100%
    );
  }
`;

const overflowStyles = css`
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ExtendedSelectorContainer = styled.div`
  display: flex;
  align-self: flex-start;
  ${overflowStyles};
`;

export const OverflowTypesWrapper = styled.div`
  position: relative;
  width: 100%;
  ${overflowStyles};
`;
